import { useAllowedMutation } from '../../shared/access/AccessControls';
import React, { useEffect, useMemo, useState } from 'react';
import MainLayout from '../../shared/components/MainLayout';
import { tagTranslationsApi } from '../../store/services/TagsTranslationService';
import { Box, Button, Flex, Spacer, Spinner, Text } from '@chakra-ui/react';
import { StyledButtonsWrapper, StyledJSONInput } from '../controlSettings/styled';
import ReactJsonEditor from 'jsoneditor-for-react';
import { useDebounce } from '../../shared/hooks/useDebounce';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../../store/slices/tagsTranslationsSlice';

const getLanguageLabel = (language: number) => {
  const labels: Record<number, string> = {
    1: 'English',
    2: 'Norwegian',
    3: 'Swedish'
  }
  return labels[language] ?? 'Unknown'
}

const ContentSettings = () => {


  const [selectedLanguage, setSelectedLanguage] = useState<number>(1);

  const [jsonString, setJsonString] = useState<string>('');
  const debouncedQuery = useDebounce(jsonString, 600);

  const onChange = (value: object) => {
    setJsonString(JSON.stringify(value));
  };

  const translations = useSelector(selectTranslations);
  const [getTranslations] = tagTranslationsApi.useLazyGetTranslationsQuery();

  useEffect(() => {
    getTranslations({});
  }, []);

  const languages = useMemo(() => {
    return translations.map((translation) => translation.language).sort();
  }, [translations]);

  useEffect(() => {
    if (!selectedLanguage && languages.length > 0) {
      setSelectedLanguage(languages[0]);
    }
  }, [languages, selectedLanguage]);

  const translation = useMemo(() => {
    return translations.find((lang) => lang.language === selectedLanguage);
  }, [translations, selectedLanguage]);

  const [updateTranslation, { isLoading }] =
    useAllowedMutation(tagTranslationsApi.useUpdateTranslationByIdMutation, 'updateTranslationById');

  const selectLanguage = (lang: number) => () => {
    setSelectedLanguage(lang);
  };

  useEffect(() => {
    if (translation) {
      updateTranslation({
        translationId: translation.id,
        data: {
          language: selectedLanguage,
          translation: debouncedQuery,
        }
      });
    }
  }, [debouncedQuery]);

  return (
    <MainLayout>
      <Box
        backgroundColor={'white'}
        padding={'1rem'}
        boxShadow="md"
        borderRadius={'md'}
      >
        <Text>Translations</Text>

        <StyledButtonsWrapper>
          {languages.map((lang) => (
            <Button
              colorScheme={(selectedLanguage === lang && 'blue') || 'gray'}
              onClick={selectLanguage(lang)}
              key={lang}
            >
              {getLanguageLabel(lang)}
            </Button>
          ))}
          <Spacer />
          {isLoading && <Spinner />}
        </StyledButtonsWrapper>
        {(translation && (
          <StyledJSONInput>
            {/*@ts-ignore*/}
            <ReactJsonEditor values={JSON.parse(translation.translation)} onChange={onChange} />
          </StyledJSONInput>
        )) || (
          <Flex justifyContent={'center'} h={'4rem'}>
            <Spinner />
          </Flex>
        )}
      </Box>
    </MainLayout>
  );
};

export default ContentSettings;